import Hogan from 'hogan.js';
import { responsiveImage, formatPrice, formatPriceWithComparison } from './utils';

export const helpers = {
  productImagePrimary: function () {
    var alt = this.title;
    var image = this._distinct ? this.product_image : this.image;

    return responsiveImage(alt, image);
  },
  productImageResponsive: function (alt, image, addSettings) {
    return responsiveImage(alt, image, addSettings);
  },
  instantsearchLink: function () {
    var addVariantId = !this._distinct && this.objectID !== this.id;
    return '/products/' + this.handle + (addVariantId ? '?variant=' + this.objectID : '');
  },
  instantsearchPrice: function () {
    if (this._distinct) {
      var min = this.variants_min_price;
      var max = this.variants_max_price;
      if (min !== max) {
        return formatPrice(min) + ' - ' + formatPrice(max);
      }
    }
    return formatPriceWithComparison(this.price, this.compare_at_price);
  },
  wishlistImage: function () {
    if (!this.image) {
      return;
    }
    var image = `${this.image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_620x620.$2')}`;
    return image;
  },
  fullTitle: function () {
    var res = this.title;
    if (!this._distinct && this.variant_title && this.variant_title !== 'Default Title' && this.variant_title !== 'Default') {
      res += ' (' + this.variant_title + ')';
    }

    const escapeHtml = (unsafe) => {
      return (unsafe || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    };

    return escapeHtml(res);
  },
  productFullLink: function () {
    if (window.location.pathname.includes('/collections')) {
      return `${window.location.origin}${window.location.pathname}/products/${this.handle}`;
    }
    return `${window.location.origin}/products/${this.handle}`;
  },
  productColorSwatches: function () {
    if (!this.colors.length) return;

    const { colorLimit } = window.algolia;

    return `
      <div
        class="product-card-colors is-flex"
        data-product-card-swatches
      >
        ${this.colors
          .map(
            ({ handle, colorLabel, colorHex }, i) => `
              <a
                href="#"
                class="product-card-colors__link ${i === 0 ? ' product-card-colors__link--is-active' : ''}${i >= colorLimit ? ' product-card-colors__link--hidden' : ''}"
                title="${colorLabel}"
                data-product-card-color-id="${handle}"
              >
                <span
                  class="product-card-colors__swatch${colorHex ? '' : ' product-card-colors__swatch--fallback'}"
                  style="${colorHex ? `background-color: ${colorHex}` : ''}"
                >
                  ${colorHex ? '' : colorLabel}
                </span>
              </a>
            `
          )
          .join('')}
          ${
            this.colors.length > colorLimit
              ? `<div class="product-card-colors__remaining" data-show-remaining-colours>
                  +${this.colors.length - colorLimit} more
                </div>`
              : ''
          }
      </div>
    `;
  },
  productBadges: function productBadges() {
    const badges = [];
    const badgeTranslations = {
      sold_out: 'Sold out',
      discount: 'Save',
      sustainable: 'Sustainable',
      new: 'New',
      bundle_and_save: 'Bundle and save',
      bestseller: 'Bestseller',
      back_in_stock: 'Back in stock',
    };

    // Sold out badge
    if (this.variants_inventory_count <= 0) {
      badges.push({
        label: badgeTranslations['sold_out'],
        customClass: 'sold-out',
      });
    }

    // Discounted badge
    if (Number(this.compare_at_price) && Number(this.compare_at_price) > Number(this.price)) {
      const salePreText = badgeTranslations['discount'];
      const saleDiscountPercentValue = Math.round((1.0 - this.price_ratio) * 100);

      badges.push({
        label: `${salePreText} ${saleDiscountPercentValue}%`,
        customClass: 'sale',
      });
    }

    // Custom badges (gotten from named tags)
    var customBadgeTags = this.named_tags['custom-badge'] || [];

    if (typeof customBadgeTags === 'string') {
      customBadgeTags = [customBadgeTags];
    }

    customBadgeTags.forEach((tag) => {
      const split = tag.split(':');
      const label = split[0]?.trim();
      const translatedLabel = badgeTranslations[label];
      const customClass = split[1]?.trim()?.toLowerCase();

      badges.push({
        label: translatedLabel || label,
        customClass: customClass,
      });
    });

    if (!badges.length) return;

    return `
      <div class="product__badges">
        ${badges
          .map(({ label, customClass }) => {
            var baseClass = 'product__badge';
            var additionalClass = customClass ? ` ${baseClass}--${customClass}` : '';

            return `
            <div class="${baseClass}${additionalClass}">${label}</div>
          `;
          })
          .join('')}
      </div>
    `;
  },
  variationTitle: function variationTitle() {
    if (this.meta?.variation?.title && this.meta?.variation?.title !== '') {
      return ` • <span class="weight-regular">${this.meta?.variation?.title}</span>`;
    } else {
      return '';
    }
  },
};

const helpersNames = Object.keys(helpers);
const helpersArray = [];

for (let i = 0; i < helpersNames.length; i += 1) {
  helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];
}

const hoganHelpers = helpersArray.reduce((res, options) => {
  const name = options[0];
  const helper = options[1];

  const newRes = {
    ...res,
  };

  newRes[name] = function () {
    return function (text) {
      const render = function (value) {
        return Hogan.compile(value, { delimiters: '[[ ]]' }).render(this);
      }.bind(this);

      return helper.call(this, text, render);
    }.bind(this);
  };

  return newRes;
}, {});

export default hoganHelpers;
